<template>
    <nav
        class="navigation-mobile"
        aria-label="Main navigation"
        :class="{'navigation-mobile--index': isIndex}"
    >
        <a
            class="navigation-mobile__burger"
            href="javascript:void(0);"
            :class="{'is-active': getBurgerMenu}"
            @click="toggleDropdown(getBurgerMenu)"
            title=""
        >
            <z-icon
                class="navigation-mobile__burger--open"
                name="burger"
            />
            <z-icon
                class="navigation-mobile__burger--close"
                name="close_light"
            />
        </a>
        <div
            class="navigation-mobile__dropdown nm-dropdown"
            v-if="getBurgerMenu"
        >
            <div class="nm-dropdown__body">
                <div class="container">
                    <div v-if="!subMenu.visible">
                        <ul class="navigation-mobile__list">
                            <li
                                class="navigation-mobile__item"
                                v-for="(item, index) in main"
                                :key="index"
                                :class="{'is-active': item.active}"

                            >
                                <span
                                    class="navigation-mobile__item-inner"
                                    @click="showSubMenu(item.items, item.name, index, item)"
                                    v-if="item.items && item.items.length"
                                >
                                    <span v-html="item.name"></span>
                                    <z-icon
                                        class="navigation-mobile__arrow navigation-mobile__arrow--right"
                                        name="arrow_bold"
                                        dir="right"
                                    />
                                </span>
                                <span
                                    class="navigation-mobile__item-inner"
                                    v-else
                                >
                                    <a
                                        :href="item.link"
                                        :title="item.name"
                                        v-html="item.name"
                                    ></a>
                                </span>
                            </li>
                        </ul>
                        <ul class="navigation-mobile__list">
                            <li
                                class="navigation-mobile__item"
                                v-for="(item, index) in top"
                                :key="index"
                                :class="{'is-active': item.active}"
                            >
                                <span
                                    class="navigation-mobile__item-inner"
                                    @click="showSubMenu(item.items, item.name, index, item)"
                                    v-if="item.items && item.items.length"
                                >
                                    <span v-html="item.name"></span>
                                    <z-icon
                                        class="navigation-mobile__arrow navigation-mobile__arrow--right"
                                        name="arrow_bold"
                                        dir="right"
                                    />
                                </span>
                                <span
                                    class="navigation-mobile__item-inner"
                                    v-else
                                >
                                    <a
                                        :href="item.link"
                                        :title="item.name"
                                        v-html="item.name"
                                    ></a>
                                </span>
                            </li>
                        </ul>
                        <ul class="navigation-mobile__list">
                            <li
                                class="navigation-mobile__item"
                                v-for="(item, index) in bottom"
                                :key="index"
                                :class="{'is-active': item.active}"
                            >
                                <span class="navigation-mobile__item-inner">
                                    <a
                                        :href="item.link"
                                        :title="item.name"
                                        v-html="item.name"
                                        :target="item.params && item.params.BLANK ? '_blank' : false"
                                    ></a>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div
                        class="navigation-mobile__submenu"
                        v-if="subMenu.visible"
                    >
                        <ul class="navigation-mobile__list">
                            <li class="navigation-mobile__item navigation-mobile__item--backlink">
                                <span
                                    class="navigation-mobile__item-inner"
                                    @click="hideSubMenu"
                                >
                                    <z-icon
                                        class="navigation-mobile__arrow navigation-mobile__arrow--left"
                                        name="arrow_bold"
                                        dir="left"
                                    />
                                    <a href="javascript:void(0);"><span>{{text.back}}</span></a>
                                </span>
                            </li>
                            <li class="navigation-mobile__item navigation-mobile__item--subindex">
                                <span class="navigation-mobile__item-inner">
                                    <a :href="subMenu.parent.link" v-html="subMenu.parent.name"></a>
                                </span>
                            </li>
                            <li
                                class="navigation-mobile__item navigation-mobile__item--lvl-2"
                                v-for="(item, index) in subMenu.items"
                                :key="index"
                                :class="{'is-active': item.active}"
                            >
                                <span class="navigation-mobile__item-inner">
                                    <template v-if="item.items.length">
                                        <span
                                            v-html="item.name"
                                            @click="showSubMenu(item.items, item.name, index, item)"
                                        ></span>
                                        <z-icon
                                            class="navigation-mobile__arrow navigation-mobile__arrow--right"
                                            name="arrow_bold"
                                            dir="right"
                                        />
                                    </template>
                                    <a
                                        v-else
                                        :href="item.link"
                                        :title="item.name"
                                        v-html="item.name"
                                    ></a>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="nm-dropdown__footer">
                <div class="container">
                    <div class="row u-flex-align--center u-flex-justify--space-between">
                        <div class="col-default-auto">
                            <site-selector></site-selector>
                        </div>
                        <div class="col-default-auto">
                            <z-link
                                class="navigation-mobile__social"
                                href="https://vk.com/club185711935"
                                size="m"
                            >
                                <z-icon
                                    class="u-collapse--all"
                                    name="social/vk"
                                    color="#15386C"
                                    height="32"
                                    width="32"
                                    dir="top"
                                />
                            </z-link>
                            <z-link
                                href="https://t.me/raspadskaya_ru"
                                size="m"
                            >
                                <z-icon
                                    class="u-collapse--all"
                                    name="social/tg"
                                    color="#15386C"
                                    height="32"
                                    width="32"
                                    dir="top"
                                />
                            </z-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'navigation-mobile',
    props: {
        isIndex: Boolean
    },
    data () {
        return {
            top: this.$root.app.components.navigation.top,
            main: this.$root.app.components.navigation.main,
            bottom: this.$root.app.components.navigation.bottom.second,
            subMenu: {
                items: [],
                header: '',
                visible: false
            },
            text: {
                lang: localize({
                    'ru': 'En',
                    'en': 'Ru'
                }),
                back: localize({
                    'ru': 'Назад',
                    'en': 'Back'
                })
            }
        }
    },
    computed: {
        getBurgerMenu () {
            return this.$store.getters.burgerMenu
        }
    },
    watch: {
        getBurgerMenu (next, prev) {
            let header = document.querySelector('.header')

            this.subMenu.visible = !(next && header)

            header.classList.toggle('is-open', next && header)
            document.body.classList.toggle('is-disabled', next && header)
        }
    },
    methods: {
        toggleDropdown (state) {
            this.$store.commit('BurgerMenu', !state)
        },
        showSubMenu (items, name, index, parent) {
            this.subMenu.parent = parent
            this.subMenu.items = items
            this.subMenu.header = name
            this.subMenu.visible = true
        },
        hideSubMenu () {
            this.subMenu.items = []
            this.subMenu.header = ''
            this.subMenu.visible = false
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
